module.exports = __webpack_public_path__ + "static/media/4-7.73c50a38.mp3";